import { defineMessages } from 'react-intl';

import { MORTGAGE_TERMS_ALL } from './mortgageTerms';


export default defineMessages({
    [MORTGAGE_TERMS_ALL]: {
        id: 'mtg-common.mortgageTerms.allTerms',
        defaultMessage: 'All',
    },
});